module.exports = __webpack_public_path__ + "img/Photo_5__Second_Canal_986_82_246.f1f43454.jpg";